module.exports = __webpack_public_path__ + "img/3-1.0c6a7317.png";